<template>
  <div class="buyer-services">
    <AppHeader logoLink="/" />

    <div class="banner centered">
      <div class="common-title__border-bottom">
        <h1>Buyer Services</h1>
      </div>
      <div class="banner-text">
        Our buyer services will help simplify your home-buying journey, and your JODI Group real estate agent won’t stop
        until you’re comfortably situated with every home feature you desire.
      </div>
    </div>

    <div class="desc centered">
      <p>
        San Francisco and the greater Bay Area offer a dizzying array of unique properties, neighborhoods, and cities to
        lay your roots. With our agents’ expertise and network, we’ll confidently present to you the best choices that
        the San Francisco real estate market has to offer. Thanks to our deep roots in the Bay Area, your Realtor® will
        also connect you with the right team of designers, lawyers, lenders, and more to properly handle every detail of
        your buying experience.
      </p>
      <p>Here’s how our buyer services will maximize the potential of your home purchase:</p>
    </div>

    <div class="list centered">
      <div class="list-inner">
        <div class="list-item">
          <div class="title"><span>01.</span>Initial Consultation</div>
          <div class="content">
            We’ll first meet with you to have a no-pressure discussion about what you’re looking for in a home. Once
            your agent has firmly established your goals, needs, and priorities, we’ll start using our expert methods to
            locate the most suitable options for you.
          </div>
        </div>

        <div class="list-item">
          <div class="title"><span>02.</span>Find The Perfect Home</div>
          <div class="content">
            Using our studied research strategies, your JODI Group real estate agent will search for properties that are
            tailored to your specifications and budget. They’ll then provide you with access to the Multiple Listing
            Service and coordinate property showings with listing agents.
          </div>
        </div>

        <div class="list-item">
          <div class="title"><span>03.</span>Submit Purchase Offers</div>
          <div class="content">
            Once you are certain and ready to make an offer on a home that fits the bill, your Realtor® will draft a
            purchase agreement for you. From then on, they’ll smooth over all complexities of the transaction, advise
            you on customary practices and regulations, and negotiate counter offers in your favor until you’ve reached
            your ideal outcome.
          </div>
        </div>

        <div class="list-item">
          <div class="title"><span>04.</span>Guide You Through Closing</div>
          <div class="content">
            We’ll coordinate and monitor the remaining financial aspects of the transaction in collaboration with the
            escrow and title company. Additionally, your agent will recommend the best vendors, schedule inspections,
            receive and review required disclosures and all other paperwork, and ensure timely removal of contract
            contingencies in compliance with local ordinances.
          </div>
        </div>

        <div class="list-item">
          <div class="title"><span>05.</span>Close of Escrow</div>
          <div class="content">
            As soon as all contingencies are removed, your agent will organize the signing for all required closing
            paperwork and verify that your homeowner’s insurance policy is in proper order. After the final property
            walk-through, they’ll arrange for your keys and occupancy.
          </div>
        </div>

        <div class="list-item">
          <div class="title"><span>06.</span>After the Sale</div>
          <div class="content">
            Once you have moved into your new home, your agent will make sure to follow-up and ensure that you are
            comfortably settled. We’ll be on deck to provide additional guidance to support you beyond the transaction
            and resolve all of your relocation needs.
          </div>
        </div>
      </div>
    </div>

    <AddonBuyerReso class="addon" />

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader'
import AppFooter from '../components/AppFooter'
import AddonBuyerReso from '../components/AddonBuyerReso'

export default {
  components: { AppHeader, AppFooter, AddonBuyerReso },
}
</script>

<style lang="less" scoped>
@import url('../assets/less/var.less');

.buyer-services {
  font-size: 14px;
  color: #333;
  text-align: center;
}

.centered {
  width: @content-width;
  margin: 0 auto;
}
.banner {
  height: 288px;
  background: url('../assets/images/buyer-services-banner.png') center no-repeat;
  background-size: cover;

  .banner-text {
    width: 436px;
    margin: 41px auto 0;
  }
}

.desc {
  padding: 46px 0 31px;

  p {
    width: 814px;
    margin: 0 auto;
    line-height: 1.8;
  }
  p:last-child {
    margin-top: 24px;
  }
}

.list {
  padding: 0 30px;
  .list-inner {
    border-top: 1px solid #d8d8d8;
    padding-top: 24px;
    padding-bottom: 81px;
    text-align: left;
  }
  .list-item {
    display: inline-block;
    width: 400px;
    margin-right: 100px;
    margin-top: 107px;

    &:nth-child(2n + 2) {
      margin-right: 0;
    }
    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 0;
    }

    .title {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      span {
        color: rgba(0, 0, 0, 0.5);
        font-weight: normal;
      }
    }
    .content {
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      margin-top: 13px;
    }
  }
}
</style>
